'use client';
import { useState, useEffect } from 'react';
 import Icon from'@/components/ui/AppIcon';

export default function StickyCTAButton() {
  const [isVisible, setIsVisible] = useState(false)
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    setIsHydrated(true)

    const handleScroll = () => {
      // Show button after scrolling 500px
      setIsVisible(window.scrollY > 500)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToForm = () => {
    const element = document.getElementById('contact-form')
    if (element) {
      const offset = 80
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
    }
  }

  if (!isHydrated || !isVisible) return null

  return (
    <button
      onClick={scrollToForm}
      className="sticky-cta md:hidden inline-flex items-center justify-center rounded-full bg-primary px-6 py-3 text-sm font-bold text-primary-foreground"
      aria-label="Vraag gratis advies aan"
    >
      <Icon name="ChatBubbleLeftRightIcon" size={20} className="mr-2" />
      Gratis advies
    </button>
  )
}